import { object, InferType, number, string } from 'yup';
import i18n from '@components/i18n';

export const healthClaimCostItemSchema = object({
  policyBenefitLimitId: string()
    .default('')
    .when('customSubBenefit', {
      is: (value: string) => value && value.length > 0,
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.required(i18n.t('validation:required'))
    }),
  declaredAmount: number()
    .default(0)
    .required(i18n.t('validation:required'))
    .positive(i18n.t('validation:positive')),
  approvedAmount: number()
    .default(0)
    .required(i18n.t('validation:required')),
  uncoveredExpensesAmount: number()
    .default(0)
    .required(i18n.t('validation:required')),
  deductibleCopayAmount: number()
    .default(0)
    .required(i18n.t('validation:required')),
  overLimitAmount: number()
    .default(0)
    .required(i18n.t('validation:required')),
  totalCoveredAmount: number()
    .default(0)
    .required(i18n.t('validation:required')),
  customSubBenefit: string()
    .default('')
    .optional(),
  remark: string()
    .default('')
    .optional(),
});

export type FormValues = InferType<typeof healthClaimCostItemSchema>;
